import { render, staticRenderFns } from "./sort-button-group.vue?vue&type=template&id=19cc78b4&scoped=true&"
import script from "./sort-button-group.vue?vue&type=script&lang=js&"
export * from "./sort-button-group.vue?vue&type=script&lang=js&"
import style0 from "./sort-button-group.vue?vue&type=style&index=0&id=19cc78b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19cc78b4",
  null
  
)

component.options.__file = "sort-button-group.vue"
export default component.exports